import { Award, Users, Clock, Globe } from 'lucide-react';
import { NavLink } from 'react-router-dom';

const AboutSection = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="section-title mx-auto inline-block after:left-1/2 after:-translate-x-1/2">
            Tentang Kami
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto mt-6">
            Sejak 2012, CV Samudera Alam Perkasa telah menjadi mitra terpercaya dalam penyediaan
            solusi tenaga kerja profesional di Indonesia.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="rounded-lg overflow-hidden shadow-lg">
            <img
              src="https://images.pexels.com/photos/3182812/pexels-photo-3182812.jpeg?auto=compress&cs=tinysrgb&w=1600"
              alt="Team meeting"
              className="w-full h-auto"
            />
          </div>

          {/* Content */}
          <div>
            <h3 className="text-2xl font-bold mb-4 text-navy-900">
              Visi & Misi Kami
            </h3>
            <p className="text-gray-700 mb-6">
              Visi kami adalah menjadi penyedia layanan tenaga kerja terkemuka di Indonesia yang memberikan
              solusi terbaik dan berkelanjutan bagi klien dan tenaga kerja. 
            </p>
            <p className="text-gray-700 mb-6">
              Misi kami adalah menghubungkan talenta terbaik dengan perusahaan yang tepat, 
              memastikan pertumbuhan berkelanjutan, dan mengembangkan potensi tenaga kerja Indonesia.
            </p>

            <div className="grid grid-cols-2 gap-6 mb-8">
              {[
                {
                  icon: <Users size={24} className="text-primary-600" />,
                  title: 'Tim Profesional',
                  description: 'Staf berpengalaman & terlatih',
                },
                {
                  icon: <Clock size={24} className="text-primary-600" />,
                  title: 'Respon Cepat',
                  description: 'Layanan efisien & tepat waktu',
                },
                {
                  icon: <Award size={24} className="text-primary-600" />,
                  title: 'Kualitas Terjamin',
                  description: 'Standar layanan terbaik',
                },
                {
                  icon: <Globe size={24} className="text-primary-600" />,
                  title: 'Jaringan Luas',
                  description: 'Menjangkau seluruh Indonesia',
                },
              ].map((item, index) => (
                <div key={index} className="flex items-start">
                  <div className="mr-3">{item.icon}</div>
                  <div>
                    <h4 className="font-semibold text-navy-900">{item.title}</h4>
                    <p className="text-sm text-gray-600">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>

            <NavLink to="/about" className="btn btn-primary">
              Pelajari Lebih Lanjut
            </NavLink>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;